import React, { useEffect } from 'react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const TestimonialCarousel = () => {
useEffect(() => {
  const swiper = new Swiper('.testimonials-carousel', {
    modules: [Navigation, Pagination],
    direction: 'horizontal',
    loop: true,
    speed: 600,
    slidesPerView: 1, // default mobile
    spaceBetween: 40,
    centeredSlides: true, // only for mobile
    allowTouchMove: true,
    grabCursor: true,
    breakpoints: {
      768: {
        slidesPerView: 3, // tablets
        centeredSlides: false,
      },
      1024: {
        slidesPerView: 3, // desktop
        centeredSlides: false,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      disabledClass: 'swiper-button-disabled',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
    },
  });

  return () => swiper.destroy(); // cleanup on unmount
}, []);

//
  const testimonials = [
    {
      name: 'Uju Fidel',
      position: 'Manager Crox Media',
      location: 'London',
      image: 'assets/img/client-img3.jpg',
      text: 'Their expertise in software development is truly exceptional. They exceeded our expectations and delivered outstanding results. A reliable partner for all your software needs. I am extremely satisfied with their services and would highly recommend them to anyone seeking top-notch software solutions.',
      rating: 5,
    },
    {
      name: 'Arish Virk',
      position: 'CEO Baroha Farms',
      location: 'Islamabad',
      image: 'assets/img/client-img2.jpeg',
      text: 'Technic Mentors is offering really very good services for web development. Our website developed by Technic Mentors is very attractive and user friendly for the use of our company employees and field users. We highly recommend Technic Mentors for Web Development Services.',
      rating: 5,
    },
    {
      name: 'Muhammad Khan',
      position: 'CEO Mobilfiksern',
      location: 'Oslo',
      image: 'assets/img/client-img1.jpeg',
      text: 'They delivered a sleek, fast, and user-friendly website that perfectly reflects our brand.  The team was responsive and professional throughout the process.From design to functionality, everything was top-notch. They even provided suggestions to improve user experience that we hadn’t thought of',
      rating: 5,
    },
      {
      name: 'Ali Khan',
      position: 'CEO TEKNOLOGIX',
      location: 'Oslo',
      image: 'assets/img/client-5.png',
      text: 'The web development team was amazing! They understood our requirements instantly and created a modern, responsive website that boosted our online engagement. Would love to work with them again. Highly Recommended!!',
      rating: 5,
    },
       {
      name: 'Sara Ahmed',
      position: 'CTO Innovatech',
      location: 'London',
      image: 'assets/img/client-6.png',
      text: 'Exceptional service and excellent communication. Our new website is not only visually stunning but also optimized for performance. The Technic Mentors team exceeded our expectations. Highly Recommended to anyone looking for top-tier web development services!',
      rating: 5,
    },
        {
      name: 'Rose Jenkins',
      position: 'Marketing Head SoftSolutions',
      location: 'Toronto',
      image: 'assets/img/client-4.jpg',
      text: 'The team at Technic Mentors offers excellent and on-schedule services. When I first discussed what I needed, they were quick to respond with perfect solution. Excellent domain knowledge and professionalism. Would love to work with them again.',
      rating: 4,
    },

  ];

  return (
    <section id="testimonials" className="testimonials-section">
      <div className="container">
        <div className="testimonials-wrapper">
           <div className="section-title text-center mb-0">
           
             <h3>  What Our <span> Clients Say</span></h3>
          </div>
          <div className="swiper-button-prev">
            <i className="bx bx-chevron-left"></i>
          </div>
          <div className="swiper-button-next">
            <i className="bx bx-chevron-right"></i>
          </div>

          <div className="testimonials-carousel swiper">
            <div className="swiper-wrapper">
              {testimonials.map((testimonial, index) => (
                <div key={index} className="swiper-slide">
                  <div className="testimonial-card">
                    <div className="quote-icon">
                      <i className="bx bxs-quote-alt-left"></i>
                    </div>
                    
                    <div className="rating">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <i key={i} className="bx bxs-star"></i>
                      ))}
                    </div>

                    <p className="testimonial-text">{testimonial.text}</p>

                    <div className="client-info">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="client-image"
                      />
                      <div className="client-details">
                        <h4>{testimonial.name}</h4>
                        <p>{testimonial.position}</p>
                        <span className="location">{testimonial.location}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="swiper-pagination"></div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .testimonials-section {
          background: #ffffff;
          position: relative;
          overflow: hidden;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
          position: relative;
        }

        .testimonials-wrapper {
          position: relative;
          padding: 0 50px;
        }

        .swiper-wrapper {
          padding: 40px 0;
        }

        .testimonial-card {
          background: #ffffff;
          border-radius: 16px;
          padding: 35px 28px;
          height: 100%;
          display: flex;
          flex-direction: column;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          transition: all 0.3s ease;
          border: 1px solid #e5e7eb;
        }

        .testimonial-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
          border-color: #667eea;
        }

        .quote-icon {
          color: #667eea;
          font-size: 40px;
          margin-bottom: 16px;
          opacity: 0.25;
        }

        .rating {
          display: flex;
          gap: 4px;
          margin-bottom: 18px;
        }

        .rating i {
          color: #fbbf24;
          font-size: 18px;
        }

        .testimonial-text {
          color: #4b5563;
          font-size: 15px;
          line-height: 1.6;
          margin-bottom: 26px;
          flex-grow: 1;
        }

        .client-info {
          display: flex;
          align-items: center;
          gap: 14px;
          padding-top: 18px;
          border-top: 1px solid #f3f4f6;
        }

        .client-image {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid #667eea;
        }

        .client-details h4 {
          color: #1f2937;
          font-size: 16px;
          font-weight: 600;
          margin: 0 0 4px 0;
        }

        .client-details p {
          color: #6b7280;
          font-size: 13px;
          margin: 0 0 2px 0;
        }

        .client-details .location {
          color: #9ca3af;
          font-size: 12px;
        }

        .swiper-button-prev,
        .swiper-button-next {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 44px;
          height: 44px;
          background: #ffffff;
          border-radius: 50%;
          color: #684df4;
          font-size: 22px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          z-index: 10;
          transition: all 0.3s ease;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
          border: 1px solid #e5e7eb;
        }

        .swiper-button-prev::after,
        .swiper-button-next::after {
          display: none;
        }

        .swiper-button-prev:hover,
        .swiper-button-next:hover {
          background: #684df4;
          color: #ffffff;
          transform: translateY(-50%) scale(1.05);
          box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
          border-color: #684df4;
        }

        .swiper-button-prev {
          left: 0;
        }

        .swiper-button-next {
          right: 0;
        }

        .swiper-button-disabled {
          opacity: 0.3;
          cursor: not-allowed;
          pointer-events: none;
        }

        .swiper-pagination {
          position: relative;
          margin-top: 30px;
          text-align: center;
        }

        .swiper-pagination-bullet {
          width: 10px;
          height: 10px;
          background: #d1d5db;
          opacity: 1;
          margin: 0 5px !important;
          border-radius: 50%;
          transition: all 0.3s ease;
        }

        .swiper-pagination-bullet-active {
          background: #684df4;
          width: 28px;
          border-radius: 5px;
        }

        @media (max-width: 768px) {
          .testimonials-wrapper {
            padding: 0 20px;
          }

          .swiper-button-prev,
          .swiper-button-next {
            width: 38px;
            height: 38px;
            font-size: 18px;
          }

          .testimonial-card {
            padding: 28px 22px;
          }

          .swiper-button-prev {
            left: -10px;
          }

          .swiper-button-next {
            right: -10px;
          }
        }
      `}</style>
    </section>
  );
};

export default TestimonialCarousel;